<template>
  <div
    class="circle-wrap"
    :class="[
      status && 'circle-active circle-active-' + status,
    ]"
  >
    <div
      class="circle-content"
      :style="{
        transition: transition,
        transform: `rotate(${this.rotate}deg) translate(-50%, -50%)`,
      }"
      @transitionend="transitionEnd"
    >
      <div class="content-dark" />
    </div>
    <div class="light">
      <div class="light-bc" />
      <div class="light-color" />
    </div>
    <div class="circle-border">
      <div class="head-icon">
        <div class="head-icon-2" />
      </div>
    </div>
    <div
      class="play-btn-mobile"
      :class="touchPlayClass"
      @click="play"
      @touchstart="touchPlay = true"
      @touchend="touchPlay = false"
    >
      <div class="clicking-block" />
      <div class="clicking-block inset-clicking" />
      <div class="play-text-bc" />
      <img src="./images/play-text.png">
    </div>
    <div
      class="play-btn pointer"
      :class="touchPlayClass"
      @click="play"
      @mousedown="touchPlayStart"
    >
      <div class="clicking-block" />
      <div class="clicking-block inset-clicking" />
      <div class="play-text-bc" />
      <img src="./images/play-text.png">
    </div>
  </div>
</template>
<script>
export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: Number,
  },
  data() {
    return {
      status: 0, // 转盘状态 0未开始 1开始加速 2匀速 3减速 4停止(停止时闪烁光标三角)
      speed: 1440,
      rotate: 0,
      transition: '',
      giftIndex: 0,
      isPlaying: false,
      touchPlay: '',
    }
  },
  computed: {
    touchPlayClass() {
      if (this.touchPlay) return 'touch-block'
      else if (this.touchPlay === false) return 'touch-end-block'
      return ''
    }
  },
  watch: {
    isPlaying(playing) {
      this.$emit('canopenrewards', !playing)
    }
  },
  methods: {
    touchPlayStart() {
      this.touchPlay = true
      document.addEventListener('mouseup', this.touchPlayEnd)
    },
    touchPlayEnd() {
      this.touchPlay = false
      document.removeEventListener('mouseup', this.touchPlayEnd)
    },
    play() {
      // 抽奖
      if (this.isPlaying) return
      if (!this.$store.state.app.userInfo) {
        this.$util.Login()
        return
      }
      if (!this.value) {
        this.$message('當前抽獎次數不足呦')
        return
      }
      this.$message('轉盤啟動中...')
      this.isPlaying = true
      this.$http.post('/activity/lolLottery/lottery')
        .then(({ data }) => {
          // 中奖
          this.reward = Object.assign(JSON.parse(data.reward), data)
          this.giftIndex = this.reward.code - 1
          this.status = 1
          const time = 1
          this.transition = `all ${time}s ease-in`
          this.rotate += this.speed * time / 2
          setTimeout(() => {
            this.status = 2
            const time = 2
            this.rotate += this.speed * time
            this.transition = `all ${time}s linear`
          }, time * 1000)
          this.$emit('getdefaultdata')
          this.$adjust('web_raffle_click', {})
        })
        .catch((data) => {
          this.isPlaying = false
          if (data.code === 9000) {
            this.$message.error(data.msg)
            this.$emit('getdefaultdata')
          } else {
            this.$message.error('網絡異常')
          }
        })
    },
    changeStatus() {
      switch (this.status) {
        case 2: {
          this.status = 3
          const time = 2
          this.rotate += this.speed * time / 2 + this.giftIndex * 60 + parseInt(Math.random() * 30) - 15
          this.transition = `all ${time}s cubic-bezier(.25,.67,.43,.92)`
          break
        }
        case 3: {
          this.status = 4
          this.$nextTick(() => {
            setTimeout(() => {
              this.$emit('showdrawdialog', this.reward)
              this.$nextTick(() => {
                this.status = 0
                this.isPlaying = false
                this.rotate = 0
                this.transition = ''
              })
            }, 2000)
          })
          break
        }
      }
    },
    transitionEnd() {
      console.log(Date.now())
      this.changeStatus()
    },
  }
}
</script>
<style lang="scss" scoped>
  $shadow-color: #8BFCFD;
  @media screen and (max-width: 599px) {
    @keyframes lightchange {
      0% {
        border-top-color: #FF5151;
      }
      25% {
        border-top-color: #FF5151;
      }
      25.01% {
        border-top-color: #FFF451;
      }
      50% {
        border-top-color: #FFF451;
      }
      50.01% {
        border-top-color: #518DFF;
      }
      75% {
        border-top-color: #518DFF;
      }
      75.01% {
        border-top-color: #51FF8C;
      }
      100% {
        border-top-color: #51FF8C;
      }
    }
    @keyframes light {
      0% {
        border-top-color: #51FF8C;
      }
      50% {
        border-top-color: #51FF8C;
      }
      50.01% {
        border-top-color: transparent;
      }
      100% {
        border-top-color: transparent;
      }
    }
    @keyframes shadow {
      0% {
        box-shadow: 0 0 0 0 $shadow-color;
      }
      100% {
        box-shadow: 0 0 10px 10px $shadow-color;
      }
    }
    @keyframes shadowIn {
      0% {
        box-shadow: inset 0 0 0 0 $shadow-color;
      }
      100% {
        box-shadow: inset 0 0 10px 10px $shadow-color;
      }
    }
    @keyframes hideShadow {
      0% {
        box-shadow: 0 0 10px 10px $shadow-color;
      }
      100% {
        box-shadow: 0 0 0 0 $shadow-color;
      }
    }
    @keyframes hideShadowIn {
      0% {
        box-shadow: inset 0 0 10px 10px $shadow-color;
      }
      100% {
        box-shadow: inset 0 0 0 0 $shadow-color;
      }
    }
    @keyframes bordershadow {
      0% {
        box-shadow: 0 0 4px 4px rgba($color: #F35657, $alpha: .3);
      }
      50% {
        box-shadow: 0 0 15px 5px #F35657;
      }
      100% {
        box-shadow: 0 0 4px 4px rgba($color: #F35657, $alpha: .3);
      }
    }
    @keyframes bordershadow2 {
      0% {
        box-shadow: 0 0 4px 4px rgba($color: #B71A1B, $alpha: .3);
      }
      50% {
        box-shadow: 0 0 15px 10px #B71A1B;
      }
      100% {
        box-shadow: 0 0 4px 4px rgba($color: #B71A1B, $alpha: .3);
      }
    }
    .circle-wrap {
      width: 278px;
      height: 278px;
      border-radius: 50%;
      position: relative;
      animation: bordershadow 8s ease-in-out infinite;
      .circle-border {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        background: url('./images/circle-border.png') no-repeat center center / 100%;
        position: relative;
        .head-icon {
          position: absolute;
          left: 50%;
          top: 7px;
          transform: translate(-50%);
          border-top: 14px solid transparent;
        }
      }
      & > div {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .light {
        width: 20px;
        height: 16px;
        transform: translate(-50%);
        top: 6px;
        &-bc {
          border-top: 16px solid #643804;
          border-right: 10px solid transparent;
          border-left: 10px solid transparent;
        }
        &-color {
          position: absolute;
          top: 0;
          left: 0;
          border-top: 16px solid transparent;
          border-right: 10px solid transparent;
          border-left: 10px solid transparent;
        }
      }
      .circle-content {
        width: 258px;
        height: 258px;
        background: url('./images/circle-content.png') no-repeat center center / 100%;
        transform-origin: left top;
        .content-dark {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          background: rgba(0, 0, 0, .6);
          transition: all .1s ease-in-out;
        }
      }
      .play-btn {
        display: none;
      }
      .play-btn-mobile {
        width: 94px;
        height: 94px;
        background: url('./images/play-btn.png') no-repeat center center / 100%;
        border-radius: 50%;
        @include flex;
        box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.5);
        & > div {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
        .play-text-bc {
          width: 78px;
          height: 78px;
          background: url('./images/play-bc.gif') no-repeat center center / 273px;
          opacity: .3;
          border-radius: 50%;
        }
        img {
          width: 90px;
          transition: all .2s ease-in-out;
          position: relative;
          z-index: 2;
        }
        .clicking-block {
          display: none;
          width: 77px;
          height: 77px;
          border-radius: 50%;
          box-shadow: 0 0 0 0 $shadow-color;
        }
        .inset-clicking {
          width: 79px;
          height: 79px;
          box-shadow: inset 0 0 0 0 $shadow-color;
        }
        &.touch-block {
          .clicking-block {
            display: block;
            box-shadow: 0 0 10px 10px $shadow-color;
            animation: shadow .2s ease-in-out 1;
          }
          .inset-clicking {
            box-shadow: inset 0 0 10px 10px $shadow-color;
            animation: shadowIn .2s ease-in-out 1;
          }
          img {
            transform: scale(.8);
          }
          .play-text-bc {
            display: none;
          }
        }
        &.touch-end-block {
          .clicking-block {
            display: block;
            animation: hideShadow .2s ease-in-out 1;
          }
          .inset-clicking {
            animation: hideShadowIn .2s ease-in-out 1;
          }
        }
      }
      &.circle-active {
        &:not(.circle-active-4) {
          animation: bordershadow2 2s ease-in-out infinite;
        }
        .circle-content {
          .content-dark {
            transform: scale(0);
          }
        }
        .play-btn-mobile {
          .play-text-bc {
            display: none;
          }
        }
      }
      &.circle-active-1 {
        .light {
          &-color {
            animation: lightchange 2s infinite;
          }
        }
      }
      &.circle-active-2 {
        .light {
          &-color {
            animation: lightchange 1s infinite;
          }
        }
      }
      &.circle-active-3 {
        .light {
          &-color {
            animation: lightchange 2s infinite;
          }
        }
      }
      &.circle-active-4 {
        .light {
          &-color {
            border-top-color: #51FF8C;
            animation: light .3s .8s 4;
          }
        }
      }
    }
  }
  @media screen and (min-width: 600px) {
    @keyframes lightchange {
      0% {
        border-top-color: #FF5151;
      }
      25% {
        border-top-color: #FF5151;
      }
      25.01% {
        border-top-color: #FFF451;
      }
      50% {
        border-top-color: #FFF451;
      }
      50.01% {
        border-top-color: #518DFF;
      }
      75% {
        border-top-color: #518DFF;
      }
      75.01% {
        border-top-color: #51FF8C;
      }
      100% {
        border-top-color: #51FF8C;
      }
    }
    @keyframes light {
      0% {
        border-top-color: #51FF8C;
      }
      50% {
        border-top-color: #51FF8C;
      }
      50.01% {
        border-top-color: transparent;
      }
      100% {
        border-top-color: transparent;
      }
    }
    @keyframes shadow {
      0% {
        box-shadow: 0 0 0 0 $shadow-color;
      }
      100% {
        box-shadow: 0 0 20px 20px $shadow-color;
      }
    }
    @keyframes shadowIn {
      0% {
        box-shadow: inset 0 0 0 0 $shadow-color;
      }
      100% {
        box-shadow: inset 0 0 20px 20px $shadow-color;
      }
    }
    @keyframes hideShadow {
      0% {
        box-shadow: 0 0 20px 20px $shadow-color;
      }
      100% {
        box-shadow: 0 0 0 0 $shadow-color;
      }
    }
    @keyframes hideShadowIn {
      0% {
        box-shadow: inset 0 0 20px 20px $shadow-color;
      }
      100% {
        box-shadow: inset 0 0 0 0 $shadow-color;
      }
    }
    @keyframes bordershadow {
      0% {
        box-shadow: 0 0 8px 8px rgba($color: #F35657, $alpha: .3);
      }
      50% {
        box-shadow: 0 0 30px 10px #F35657;
      }
      100% {
        box-shadow: 0 0 8px 8px rgba($color: #F35657, $alpha: .3);
      }
    }
    @keyframes bordershadow2 {
      0% {
        box-shadow: 0 0 8px 8px rgba($color: #B71A1B, $alpha: .3);
      }
      50% {
        box-shadow: 0 0 30px 20px #B71A1B;
      }
      100% {
        box-shadow: 0 0 8px 8px rgba($color: #B71A1B, $alpha: .3);
      }
    }
    .circle-wrap {
      width: 448px;
      height: 448px;
      border-radius: 50%;
      position: absolute;
      top: 153px;
      left: 50%;
      transform: translate(92px);
      animation: bordershadow 8s ease-in-out infinite;
      .circle-border {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        background: url('./images/circle-border.png') no-repeat center center / 100%;
        position: relative;
        .head-icon {
          position: absolute;
          left: 50%;
          top: 14px;
          transform: translate(-50%);
          border-top: 28px solid transparent;
        }
      }
      & > div {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .light {
        width: 29px;
        height: 22px;
        transform: translate(-50%);
        top: 11px;
        &-bc {
          border-top: 24px solid #643804;
          border-right: 16px solid transparent;
          border-left: 16px solid transparent;
        }
        &-color {
          position: absolute;
          top: 0;
          left: 0;
          border-top: 24px solid transparent;
          border-right: 16px solid transparent;
          border-left: 16px solid transparent;
        }
      }
      .circle-content {
        width: 420px;
        height: 420px;
        background: url('./images/circle-content.png') no-repeat center center / 100%;
        transform-origin: left top;
        .content-dark {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          background: rgba(0, 0, 0, .6);
          transition: all .1s ease-in-out;
        }
      }
      .play-btn {
        width: 152px;
        height: 152px;
        background: url('./images/play-btn.png') no-repeat center center / 100%;
        border-radius: 50%;
        @include flex;
        box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.5);
        user-select: none;
        -moz-user-select: none;
        -webkit-user-select: none;
        & > div {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
        .play-text-bc {
          width: 122px;
          height: 122px;
          background: url('./images/play-bc.gif') no-repeat center center / 400px;
          opacity: .3;
          border-radius: 50%;
        }
        img {
          width: 144px;
          transition: all .2s ease-in-out;
          position: relative;
          z-index: 2;
          user-select: none;
          -moz-user-select: none;
          -webkit-user-select: none;
        }
        .clicking-block {
          display: none;
          width: 120px;
          height: 120px;
          border-radius: 50%;
          box-shadow: 0 0 0 0 $shadow-color;
        }
        .inset-clicking {
          width: 124px;
          height: 124px;
          box-shadow: inset 0 0 0 0 $shadow-color;
        }
        &.touch-block {
          .clicking-block {
            display: block;
            box-shadow: 0 0 20px 20px $shadow-color;
            animation: shadow .2s ease-in-out 1;
          }
          .inset-clicking {
            box-shadow: inset 0 0 20px 20px $shadow-color;
            animation: shadowIn .2s ease-in-out 1;
          }
          img {
            transform: scale(.8);
          }
          .play-text-bc {
            display: none;
          }
        }
        &.touch-end-block {
          .clicking-block {
            display: block;
            animation: hideShadow .2s ease-in-out 1;
          }
          .inset-clicking {
            animation: hideShadowIn .2s ease-in-out 1;
          }
        }
      }
      .play-btn-mobile {
        display: none;
      }
      &.circle-active {
        &:not(.circle-active-4) {
          animation: bordershadow2 2s ease-in-out infinite;
        }
        .circle-content {
          .content-dark {
            transform: scale(0);
          }
        }
        .play-btn {
          .play-text-bc {
            display: none;
          }
        }
      }
      &.circle-active-1 {
        .light {
          &-color {
            animation: lightchange 2s infinite;
          }
        }
      }
      &.circle-active-2 {
        .light {
          &-color {
            animation: lightchange 1s infinite;
          }
        }
      }
      &.circle-active-3 {
        .light {
          &-color {
            animation: lightchange 2s infinite;
          }
        }
      }
      &.circle-active-4 {
        .light {
          &-color {
            border-top-color: #51FF8C;
            animation: light .3s .8s 4;
          }
        }
      }
    }
  }
</style>
